<template>
    <div class="login-box">
        <em class="logo ng-scope"></em>
        <div class="col col-md-4 text-center login-text  my-auto">
            <div class="centered">
                <h3>Having trouble signing in?</h3>
                <p>Enter your email address below and we’ll get you back on track.</p>
            </div>
            <div class="login-form">
                <div class="fields">
                    <div class="line-item">
                        <md-field>
                            <md-input id="email" v-model="email" type="email" placeholder="Email" class="login-input"></md-input>
                        </md-field>
                        <p v-if="emialValid" class="validationMessage">Account not Found. Please use valid email</p>
                        <p v-if="validEMaliReq" class="validationMessage">Enter Email Address </p>
                    </div>
                    <div class="actions">
                        <md-button id="send-email" class="md-primary md-ink-ripple md-raised" v-on:click="sendEmail()">Request
                            Reset Link
                        </md-button>
                        <p class="centered">
                            <a class="login-text text-center" v-on:click="returnToLogin()">Back to sign in</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
import {mapActions} from 'vuex';
import {sendResetEmail} from '../../services/LoginService';

export default {
  data: () => ({
    email: '',
    emialValid: false,
    validEMaliReq: false
  }),
  methods: {
    ...mapActions('user', ['sendResetPasswordEmail']),
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    sendEmail () {
      if (!this.validEmail(this.email)) {
        this.validEMaliReq = true;
        setTimeout(() => {
          this.validEMaliReq = false;
        }, 3000);
      } else {
        let pp = this;
        sendResetEmail(this.email).then(function (defs) {
          if (defs.data.message === 'Account was not Found') {
            pp.emialValid = true;
            pp.$router.push('/email/sent');
          } else {
            pp.$router.push('/email/sent');
          }
        });
      }
    },
    returnToLogin () {
      this.$router.push('/login');
    }
  }
};
</script>

<style scoped type="scss">
.validationMessage {
    color: red;
}

.logo {
    overflow: hidden;
    background: url(/static/img/logo.png);
    background-size: 288px 90px;
    width: 288px;
    height: 90px;
    margin: auto;
}

#send-email {
    width: 100%;
    background-color: rgb(0, 168, 202) !important;
    color: white;
}

.login-text {
    width: 420px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/user/ForgotPassword.vue